import { NumberPoolService } from "@/api/number-pool";
import {
	VOIP_NUMBER_POOL_FETCH_AVAILABLE_NUMBERS_ACTION,
	VOIP_NUMBER_POOL_FETCH_PREFIXES_ACTION,
	VOIP_NUMBER_POOL_RESERVE_NUMBER_ACTION,
	VOIP_NUMBER_POOL_SET_AVAILABLE_NUMBERS,
	VOIP_NUMBER_POOL_SET_PREFIXES
} from "./constants";
import { VoipNumberPoolState } from "./module";
import { DataConfigurationService } from "@/api/data-configuration";

const fetchAvailableNumbers = ({ commit, state }: any & { state: VoipNumberPoolState }) => {
	return new Promise((resolve, reject) => {
		if (state.availableNumbers && Array.isArray(state.availableNumbers) && state.availableNumbers.length > 0) {
			resolve(undefined);
			return;
		}

		NumberPoolService.fetchProvinceAvailableNumbers(state.province)
			.then((availableNumbers) => {
				commit(VOIP_NUMBER_POOL_SET_AVAILABLE_NUMBERS, availableNumbers);

				resolve(undefined);
			})
			.catch(reject);
	});
};

const reserveNumber = ({ dispatch }: any, number: string) => {
	return new Promise((resolve, reject) => {
		NumberPoolService.reserveNumber(number)
			.then(() => {
				dispatch(VOIP_NUMBER_POOL_FETCH_AVAILABLE_NUMBERS_ACTION);
				resolve(undefined);
			})
			.catch(reject);
	});
};

const fetchPrefixes = ({ commit, state }: any & { state: VoipNumberPoolState }) => {
	return new Promise((resolve, reject) => {
		const province = state.province;
		DataConfigurationService.fetchProvincePrefixes(province)
			.then((prefixes) => {
				commit(VOIP_NUMBER_POOL_SET_PREFIXES, prefixes);

				resolve(undefined);
			})
			.catch(reject);
	});
};

export default {
	[VOIP_NUMBER_POOL_FETCH_AVAILABLE_NUMBERS_ACTION]: fetchAvailableNumbers,
	[VOIP_NUMBER_POOL_FETCH_PREFIXES_ACTION]: fetchPrefixes,
	[VOIP_NUMBER_POOL_RESERVE_NUMBER_ACTION]: reserveNumber
};
